<template>
  <svg class="icon"
       width="17"
       height="17"
       viewBox="0 0 17 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M14.4814 11.931C13.0967 11.931 11.9629 13.0648 11.9629 14.4495C11.9629 15.8342 13.0967 16.968 14.4814 16.968C15.8661 16.968 16.9999 15.8342 16.9999 14.4495C16.9999 13.0648 15.8661 11.931 14.4814 11.931ZM15.3004 15.5513L14.4814 15.1111L13.6624 15.5513L13.8198 14.6389L13.1582 14.0093L14.0706 13.8838L14.4802 13.0648L14.8897 13.8838L15.8021 14.0093L15.1405 14.6389L15.3004 15.5513ZM11.3961 15.1111C11.4908 15.5206 11.6482 15.9301 11.9003 16.2757C10.8612 16.7479 9.69661 17 8.5 17C3.80989 17 0 13.1901 0 8.5C0 3.80989 3.80989 0 8.5 0C13.1901 0 17 3.80989 17 8.5C17 9.69655 16.7479 10.8611 16.2757 11.9003C15.7727 11.5216 15.1431 11.3014 14.4815 11.3014C13.7572 11.3014 13.0968 11.5535 12.5606 11.9631C11.7736 11.208 10.7664 10.7038 9.66456 10.4837C10.9865 10.0102 11.963 8.72021 11.963 7.20898C11.963 5.2881 10.4209 3.74601 8.5 3.74601C6.57912 3.74601 5.03704 5.2881 5.03704 7.20898C5.03704 8.72034 6.01347 10.0103 7.33544 10.4824C5.57197 10.8292 4.09253 11.9311 3.24284 13.4732C4.5968 14.8591 6.45364 15.7088 8.49994 15.7088C9.53908 15.7088 10.5142 15.4887 11.396 15.1112L11.3961 15.1111Z" />
  </svg>
</template>

<script>
export default {
  name: 'SuperAdmin',
};
</script>
